/* Al-Aqeeq: the bag lifts, tips and pours bouncing beans into a pile; aroma rises; cards tilt in 3D. */
(function () {
  var scenes = document.querySelectorAll('[data-yc-pour]');
  if (!scenes.length) return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia && window.matchMedia('(pointer: fine)').matches;
  var COLORS = ['#3a2115', '#4a2b1a', '#2f190f', '#5b3522', '#432616'];

  function drawBean(ctx, x, y, r, a, col) {
    ctx.save(); ctx.translate(x, y); ctx.rotate(a);
    var g = ctx.createRadialGradient(-r * 0.35, -r * 0.4, r * 0.1, 0, 0, r * 1.3);
    g.addColorStop(0, '#9a6239'); g.addColorStop(0.45, col); g.addColorStop(1, '#160a05');
    ctx.fillStyle = g; ctx.beginPath(); ctx.ellipse(0, 0, r * 1.25, r * 0.88, 0, 0, 6.2832); ctx.fill();
    ctx.strokeStyle = 'rgba(12,5,2,.9)'; ctx.lineWidth = Math.max(1, r * 0.22);
    ctx.beginPath(); ctx.moveTo(-r, 0); ctx.bezierCurveTo(-r * 0.35, -r * 0.35, r * 0.35, r * 0.35, r, 0); ctx.stroke();
    ctx.fillStyle = 'rgba(255,225,180,.3)'; ctx.beginPath(); ctx.ellipse(-r * 0.45, -r * 0.4, r * 0.38, r * 0.16, -0.4, 0, 6.2832); ctx.fill();
    ctx.restore();
  }

  function Scene(el) {
    this.el = el;
    this.cv = el.querySelector('.yc-bag__beans');
    this.mouth = el.querySelector('.yc-bag__mouth');
    this.ctx = this.cv.getContext('2d');
    this.mode = el.getAttribute('data-yc-mode') || 'pour';
    this.done = false; this.busy = false; this.visible = false;
    this.wisps = []; this.live = []; this.settled = [];
  }

  Scene.prototype.size = function () {
    var r = this.el.getBoundingClientRect(), d = Math.min(window.devicePixelRatio || 1, 2);
    this.w = r.width; this.h = r.height;
    this.cv.width = Math.round(r.width * d); this.cv.height = Math.round(r.height * d);
    this.ctx.setTransform(d, 0, 0, d, 0, 0);
    this.r = Math.max(3.2, Math.min(6, r.width / 85));
    this.floor = r.height * 0.9;
    this.bin = this.r * 1.6;
    this.heights = new Array(Math.ceil(r.width / this.bin) + 1).fill(0);
    this.settled = []; this.live = [];
    this.pile = document.createElement('canvas');
    this.pile.width = this.cv.width; this.pile.height = this.cv.height;
    this.pctx = this.pile.getContext('2d'); this.pctx.setTransform(d, 0, 0, d, 0, 0);
    this.pctx.fillStyle = 'rgba(0,0,0,.3)'; this.pctx.beginPath();
    this.pctx.ellipse(r.width * 0.4, this.floor + this.r, r.width * 0.32, this.r * 2.4, 0, 0, 6.2832); this.pctx.fill();
  };

  Scene.prototype.settle = function (b) {
    var i = Math.max(0, Math.min(this.heights.length - 1, Math.round(b.x / this.bin)));
    for (var k = 0; k < 8; k++) {
      var l = this.heights[i - 1], rr = this.heights[i + 1], h = this.heights[i];
      if (l !== undefined && l < h - this.r * 1.1 && (rr === undefined || l <= rr)) i--;
      else if (rr !== undefined && rr < h - this.r * 1.1) i++;
      else break;
    }
    b.x = i * this.bin + (Math.random() - 0.5) * this.bin * 0.7;
    b.y = this.floor - this.heights[i] - this.r * 0.6;
    this.heights[i] += this.r * 1.0;
    this.settled.push(b);
    drawBean(this.pctx, b.x, b.y, this.r, b.a, b.c);
  };

  Scene.prototype.spawn = function () {
    var cr = this.el.getBoundingClientRect(), m = this.mouth.getBoundingClientRect();
    var x = m.left - cr.left + m.width / 2, y = m.top - cr.top + m.height / 2;
    var fo = this.mode === 'fountain';
    this.live.push({ x: x + (Math.random() - 0.5) * this.r * (fo ? 5 : 3), y: y + (Math.random() - 0.5) * this.r * 2, vx: fo ? (Math.random() - 0.62) * 4.2 : -(0.45 + Math.random() * 1.3), vy: fo ? -(4.2 + Math.random() * 2.6) : -0.6 + Math.random() * 1.0, a: Math.random() * 6.28, va: (Math.random() - 0.5) * 0.35, b: 0, c: COLORS[(Math.random() * COLORS.length) | 0] });
  };

  Scene.prototype.wisp = function (t) {
    var top = this.floor - Math.max.apply(null, this.heights);
    this.wisps.push({ x: this.w * (0.22 + Math.random() * 0.3), y: Math.min(this.floor - this.r * 2, top + this.r * 3), born: t, life: 2600 + Math.random() * 1600, ph: Math.random() * 6.28, amp: 4 + Math.random() * 6, rise: this.h * (0.35 + Math.random() * 0.25) });
  };

  Scene.prototype.render = function (t) {
    var c = this.ctx;
    c.clearRect(0, 0, this.w, this.h);
    c.drawImage(this.pile, 0, 0, this.w, this.h);
    for (var i = 0; i < this.live.length; i++) { var b = this.live[i]; drawBean(c, b.x, b.y, this.r, b.a, b.c); }
    if (!this.wisps.length) return;
    c.save(); c.globalCompositeOperation = 'lighter'; c.lineCap = 'round';
    for (var j = this.wisps.length - 1; j >= 0; j--) {
      var w = this.wisps[j], age = (t - w.born) / w.life;
      if (age >= 1) { this.wisps.splice(j, 1); continue; }
      var f = Math.sin(age * Math.PI), len = Math.min(1, age * 1.5);
      c.beginPath();
      for (var s = 0; s <= 10; s++) {
        var u = s / 10 * len, sx = w.x + Math.sin(w.ph + u * 5 + t / 800) * w.amp * (0.4 + u), sy = w.y - u * w.rise - age * 10;
        s ? c.lineTo(sx, sy) : c.moveTo(sx, sy);
      }
      c.strokeStyle = 'rgba(255,244,228,' + 0.05 * f + ')'; c.lineWidth = 9; c.stroke();
      c.strokeStyle = 'rgba(255,248,238,' + 0.11 * f + ')'; c.lineWidth = 3; c.stroke();
    }
    c.restore();
  };

  Scene.prototype.loop = function () {
    var s = this;
    if (s.raf) return;
    var last = 0, nextW = 0;
    function tick(now) {
      var t = now - s.t0, total = s.pourCount, k = Math.min(3, (now - (last || now)) / 16.7); last = now;
      if (s.pouring) {
        var st = s.mode === 'fountain' ? 450 : 1050;
        if (t > st && s.made < total) {
          var want = Math.min(total, Math.round((t - st) / 2300 * total));
          if (s.mode === 'fountain' && Math.sin((t - st) / 120) < -0.2) want = s.made; /* pulses */
          while (s.made < want) { s.spawn(); s.made++; }
        }
        if (t > (s.mode === 'fountain' ? 3300 : 3500) && s.made >= total) { s.pouring = false; s.el.classList.remove('is-pour'); s.el.classList.add('is-settle'); setTimeout(function () { s.el.classList.remove('is-settle'); }, 900); }
      }
      for (var i = s.live.length - 1; i >= 0; i--) {
        var b = s.live[i];
        b.vy += 0.34 * k; b.x += b.vx * k; b.y += b.vy * k; b.a += b.va * k;
        var bi = Math.max(0, Math.min(s.heights.length - 1, Math.round(b.x / s.bin)));
        var gy = s.floor - s.heights[bi] - s.r * 0.6;
        if (b.y >= gy) {
          if (b.b < 2 && b.vy > 2.2) { b.y = gy; b.vy *= -0.38; b.vx = b.vx * 0.6 + (Math.random() - 0.5) * 1.2; b.va *= 0.5; b.b++; }
          else { s.live.splice(i, 1); s.settle(b); }
        }
      }
      if (!s.pouring && !s.live.length) s.busy = false;
      if (s.visible && s.settled.length > 20 && !reduce && now > nextW) { s.wisp(now); nextW = now + 500 + Math.random() * 500; }
      s.render(now);
      if (s.live.length || s.pouring || (s.visible && s.wisps.length) || (s.visible && s.settled.length > 20)) s.raf = requestAnimationFrame(tick);
      else { s.raf = 0; s.busy = false; }
    }
    s.raf = requestAnimationFrame(tick);
  };

  Scene.prototype.play = function () {
    if (!this.done) { this.done = true; this.size(); }
    if (this.busy) return;
    if (reduce) { this.staticPile(90); return; }
    this.busy = true;
    var cap = 320;
    this.pourCount = Math.max(0, Math.min(Math.round(Math.min(150, this.w / 2.6)), cap - this.settled.length));
    if (!this.pourCount) { this.busy = false; return; }
    this.pouring = true; this.t0 = performance.now(); this.made = 0;
    this.el.classList.remove('is-settle'); this.el.classList.add('is-pour');
    this.loop();
  };

  Scene.prototype.staticPile = function (n) {
    for (var i = 0; i < n; i++) this.settle({ x: this.w * (0.18 + Math.random() * 0.42), y: 0, a: Math.random() * Math.PI, c: COLORS[(Math.random() * COLORS.length) | 0] });
    this.render(0);
  };

  /* 3D tilt + shine for the card that holds the scene */
  function tilt(card) {
    if (!fine || reduce || !card) return;
    card.classList.add('yc-tilt');
    card.addEventListener('pointermove', function (e) {
      var r = card.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
      card.style.setProperty('--rx', (y * -6).toFixed(2) + 'deg');
      card.style.setProperty('--ry', (x * 8).toFixed(2) + 'deg');
      card.style.setProperty('--sx', ((x + 0.5) * 100).toFixed(1) + '%');
      card.style.setProperty('--sy', ((y + 0.5) * 100).toFixed(1) + '%');
    });
    card.addEventListener('pointerleave', function () { card.style.setProperty('--rx', '0deg'); card.style.setProperty('--ry', '0deg'); });
  }

  var list = [];
  scenes.forEach(function (el) {
    var s = new Scene(el); list.push(s);
    tilt(el.closest('.yc-pc, .yc-cc'));
    var host = el.closest('.yc-pc, .yc-cc, .yc-pr__promo') || el;
    host.addEventListener('mouseenter', function () { if (s.done && !s.busy) s.play(); });
  });
  if (!('IntersectionObserver' in window)) { list.forEach(function (s) { s.visible = true; s.play(); }); return; }
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      list.forEach(function (s) {
        if (s.el !== e.target) return;
        s.visible = e.isIntersecting;
        if (e.isIntersecting && e.intersectionRatio > 0.45 && !s.done) s.play();
        else if (e.isIntersecting && s.done && !s.raf) s.loop();
      });
    });
  }, { threshold: [0, 0.45] });
  list.forEach(function (s) { io.observe(s.el); });
  var rt;
  window.addEventListener('resize', function () {
    clearTimeout(rt);
    rt = setTimeout(function () {
      list.forEach(function (s) { if (s.done && !s.live.length) { var n = s.settled.length; s.size(); s.staticPile(n); } });
    }, 200);
  });
})();
